import {FC} from 'react';
import {FieldError} from 'react-hook-form';
import {twMerge} from 'tailwind-merge';
import {c} from 'ttag';

type FieldOptionalTextProps = {
    className?: string;
    disabled?: boolean;
    error?: FieldError;
};

const FieldOptionalText: FC<FieldOptionalTextProps> = ({
    className,
    disabled,
    error,
}) => (
    <div
        className={twMerge(
            'ml-4 w-fit select-none rounded border px-1 py-px text-xs font-normal',
            disabled && 'border-light-disabled text-light-disabled',
            !disabled && 'border-grey-400 text-light-secondary',
            !disabled && error && 'bg-grey-600 border-grey-600 text-white',
            className,
        )}
        data-field-optional-text={true}
        role="status"
    >
        {c('component').t`Optional`}
    </div>
);

export default FieldOptionalText;
